<template >
	<el-row class="container" >
		<el-col :span="24" class="header" :style="headerbackground">
			<el-col :span="4" class="logo" :class="collapsed"  >
				{{collapsed?'':sysName}}
			</el-col>
			<!-- <el-col :span="10">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col> -->
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><img :src="userImg" style="width:35px;height:35px"/> {{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item @click.native="Dist()" >点我定位</el-dropdown-item> -->
						<!-- <el-color-picker  @change="colorChange" v-model="colors.primary" ></el-color-picker> -->
				
						<el-dropdown-item >
  <a target="_blank" :href="CustomerServiceUrl">联系QQ客服</a>
</el-dropdown-item>
						<el-dropdown-item @click.native="QRcode" >联系微信客服</el-dropdown-item>
						<!-- <el-dropdown-item @click.native="QRcode()" >我的分享码</el-dropdown-item> -->
						<el-dropdown-item @click.native="ChangePassword" >修改密码</el-dropdown-item>
						<!-- <el-dropdown-item>设置</el-dropdown-item> -->
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'" >
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
							<el-menu-item  v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item style="width: 160px;" v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
						<template v-if="!item.leaf">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="28" class="breadcrumb-container">
						<!-- <strong class="title">{{$route.name}}</strong> -->
						<el-breadcrumb separator="/" class="breadcrumb-inner" v-if="$route.name=='统计图表'">
						</el-breadcrumb>
	                    <el-breadcrumb separator="/" class="breadcrumb-inner" v-else-if="$route.name=='会员信息'">
						</el-breadcrumb>				
						<el-breadcrumb separator="/" class="breadcrumb-inner" v-else>
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path" >
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="28" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
							

			</section>
		</el-col>
		<el-col :span="24">
       	<div class="containerfooterdiv"> <el-col class="containerfooter">温州智考评软件有限公司</el-col></div>	  

		</el-col>
        		<!--修改密码-->
		<el-dialog title="修改密码" v-model="FormVisible" :close-on-click-modal="false" custom-class style="width:50%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">
			<el-form :model="Form" label-width="100px" :rules="FormRules" ref="Form">
				<el-form-item label="老密码" prop="OldPwd">
					<el-input v-model="Form.OldPwd" type="password" placeholder="请输老密码" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="NewPwd">
					<el-input v-model="Form.NewPwd" type="password" placeholder="请输新密码" auto-complete="off"></el-input>
				</el-form-item>	
				<el-form-item label="确认新密码" prop="Confirm">
					<el-input v-model="Form.Confirm" type="password" placeholder="确认新密码" auto-complete="off"></el-input>
				</el-form-item>					
		    </el-form>
						 
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="FormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="Change" >提交</el-button>
			</div>
			
		</el-dialog>

		<el-dialog title="设置门店定位" v-model="DistVisible" :close-on-click-modal="false" >
             <el-form >
				<el-form-item label="设置定位" prop="Confirm">
		
<el-cascader ref="cascaderAddr" size="medium" @change="onProvincesChange" :options="options" v-model="value" filterable clearable placeholder="选择或搜索定位" style="width:100%">
	
  <template slot-scope="{ node, data }">
    <span>{{ data.label }}</span>
    <span > () </span>
  </template>
</el-cascader>
					</el-form-item>					 
			 </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="DistVisible = false">取消</el-button>
				<el-button type="primary" @click.native="ChangeDist" >提交</el-button>
			</div>
		</el-dialog>
		

  <el-dialog title="设置门店游泳时限" v-model="LimitVisible" :close-on-click-modal="false" style="width:50%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;">
             <el-form >
				<el-form-item label="设置时限单位(H)" prop="Confirm">	
					<el-input-number v-model="LimitTime" :min="1" :max="24" label="描述文字"></el-input-number>	
					</el-form-item>					 
			 </el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="LimitVisible = false">取消</el-button>
				<el-button type="primary" @click.native="ChangeTime" >提交</el-button>
			</div>
		</el-dialog>		

    <el-dialog title="查看大图" v-model="seeImageVisible">
					<div style="width:100%;margin:0 auto; text-align:center;"><img   :src="CustomerServiceImgUrl" style=" background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; "></div>
			
		</el-dialog>
	</el-row>
     

       

</template>

<script>
//通过sessionStorage将用户信息持久化在状态管理器中
import {QQCustomerService,TimeLimitSet,GetHtmlValue,requestLogout,ChangePassword,getShopInfor,DistJsonList,CreateShopDist,GetDistShopList,JsonList,VersionStyle}  from '../api/api';
import {mapState, mapMutations,mapGetters, mapActions} from 'vuex';
import {usermodel} from '../model/models';
import  userlist from '../userroutes/routeschange'
import landlordlist from '../userroutes/landlord'
import routes from '../routes'
import userImg from "../assets/user.jpg"
import CustomerServiceImg from "../assets/WeChatCustomerService.png"
import generateColors from "../utils/color";
import objectAssign from "object-assign";
	export default {
		data() {
			return {
			
			   	headerbackground:'background-color:',
           originalStylesheetCount: -1,//记录当前已引入style数量
            originalStyle: "",//获取拿到的.css的字符串
            colors: {
                //颜色选择器默认颜色值,这个值要和element-variables一样
                primary: "#3f007d"
            },
            // primaryColor: "", //提交成功后设置默认颜色
            
                // "//unpkg.com/element-ui/lib/theme-chalk/index.css",
               cssUrl:  "./static/css/index.css",
						
						cssColor:[						
						],
								// {index:0,color:"",fileurl:"./static/css/index.css"},
 								// {index:1,color:"",fileurl:"./static/css/index.css"},
 								// {index:1,color:"",fileurl:"./static/css/index.css"}				
				userName:'',
				CustomerServiceUrl:'',
				CustomerServiceImgUrl:CustomerServiceImg,
				imgUrl:'',
				seeImageVisible:false,
				LimitTime:0,
				LimitVisible:false,

				//修改密码相关
				DistVisible:false,
				value:[],
				// options:[],
     options: [{
          value: 'zhinan',
          label: '指南',
          children: [{
            value: 'shejiyuanze',
            label: '设计原则',
            children: [{
              value: 'yizhi',
              label: '一致'
            }, {
              value: 'fankui',
              label: '反馈'
            }, {
              value: 'xiaolv',
              label: '效率'
            }, {
              value: 'kekong',
              label: '可控'
            }]
          }, {
            value: 'daohang',
            label: '导航',
            children: [{
              value: 'cexiangdaohang',
              label: '侧向导航'
            }, {
              value: 'dingbudaohang',
              label: '顶部导航'
            }]
          }]
        }, {
          value: 'zujian',
          label: '组件',
          children: [{
            value: 'basic',
            label: 'Basic',
            children: [{
              value: 'layout',
              label: 'Layout 布局'
            }, {
              value: 'color',
              label: 'Color 色彩'
            }, {
              value: 'typography',
              label: 'Typography 字体'
            }, {
              value: 'icon',
              label: 'Icon 图标'
            }, {
              value: 'button',
              label: 'Button 按钮'
            }]
          }, {
            value: 'form',
            label: 'Form',
            children: [{
              value: 'radio',
              label: 'Radio 单选框'
            }, {
              value: 'checkbox',
              label: 'Checkbox 多选框'
            }, {
              value: 'input',
              label: 'Input 输入框'
            }, {
              value: 'input-number',
              label: 'InputNumber 计数器'
            }, {
              value: 'select',
              label: 'Select 选择器'
            }, {
              value: 'cascader',
              label: 'Cascader 级联选择器'
            }, {
              value: 'switch',
              label: 'Switch 开关'
            }, {
              value: 'slider',
              label: 'Slider 滑块'
            }, {
              value: 'time-picker',
              label: 'TimePicker 时间选择器'
            }, {
              value: 'date-picker',
              label: 'DatePicker 日期选择器'
            }, {
              value: 'datetime-picker',
              label: 'DateTimePicker 日期时间选择器'
            }, {
              value: 'upload',
              label: 'Upload 上传'
            }, {
              value: 'rate',
              label: 'Rate 评分'
            }, {
              value: 'form',
              label: 'Form 表单'
            }]
          }, {
            value: 'data',
            label: 'Data',
            children: [{
              value: 'table',
              label: 'Table 表格'
            }, {
              value: 'tag',
              label: 'Tag 标签'
            }, {
              value: 'progress',
              label: 'Progress 进度条'
            }, {
              value: 'tree',
              label: 'Tree 树形控件'
            }, {
              value: 'pagination',
              label: 'Pagination 分页'
            }, {
              value: 'badge',
              label: 'Badge 标记'
            }]
          }, {
            value: 'notice',
            label: 'Notice',
            children: [{
              value: 'alert',
              label: 'Alert 警告'
            }, {
              value: 'loading',
              label: 'Loading 加载'
            }, {
              value: 'message',
              label: 'Message 消息提示'
            }, {
              value: 'message-box',
              label: 'MessageBox 弹框'
            }, {
              value: 'notification',
              label: 'Notification 通知'
            }]
          }, {
            value: 'navigation',
            label: 'Navigation',
            children: [{
              value: 'menu',
              label: 'NavMenu 导航菜单'
            }, {
              value: 'tabs',
              label: 'Tabs 标签页'
            }, {
              value: 'breadcrumb',
              label: 'Breadcrumb 面包屑'
            }, {
              value: 'dropdown',
              label: 'Dropdown 下拉菜单'
            }, {
              value: 'steps',
              label: 'Steps 步骤条'
            }]
          }, {
            value: 'others',
            label: 'Others',
            children: [{
              value: 'dialog',
              label: 'Dialog 对话框'
            }, {
              value: 'tooltip',
              label: 'Tooltip 文字提示'
            }, {
              value: 'popover',
              label: 'Popover 弹出框'
            }, {
              value: 'card',
              label: 'Card 卡片'
            }, {
              value: 'carousel',
              label: 'Carousel 走马灯'
            }, {
              value: 'collapse',
              label: 'Collapse 折叠面板'
            }]
          }]
        }, {
          value: 'ziyuan',
          label: '资源',
          children: [{
            value: 'axure',
            label: 'Axure Components'
          }, {
            value: 'sketch',
            label: 'Sketch Templates'
          }, {
            value: 'jiaohu',
            label: '组件交互文档'
          }]
        }],			
				Form:{
					UserId:'',
					OldPwd:'',
					NewPwd:'',
					Confirm:''
				},
				userImg:userImg,
				FormVisible:false,
                FormRules:{
                        OldPwd: [
						{ required: true, message: '请输入老密码', trigger: 'blur' }
					],
					 NewPwd: [
						{ required: true, message: '请输入新密码', trigger: 'blur' }
					],
					Confirm: [
						{ required: true, message: '请输入新密码', trigger: 'blur' }
					],
				},

               
				sysName:'智考评体育服务平台-游泳版',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				shopName:'',
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		created () {			
		this.listenerFunction();
		 },
	methods: {
    listenerFunction(e) {
        document.addEventListener('scroll', this.handleScroll, true);
    },
    handleScroll () {
			var classObj = document.getElementsByClassName('expand-trigger');
			if (typeof(classObj) == undefined)
                {			
				}else
				{
					for (var index = 0; index < classObj.length; index++) {
						classObj[index].style.height="1px"						
					}
				}			
    },	
	       colorChange(e) {
            if(!e)return;
            localStorage.setItem('color',e)
            this.primaryColor = this.colors.primary;
            this.colors = objectAssign(
                {},
                this.colors,
                generateColors(this.colors.primary)
            );
            this.writeNewStyle();
        },
        writeNewStyle() {
            let cssText = this.originalStyle;
            Object.keys(this.colors).forEach(key => {
                cssText = cssText.replace(
                    new RegExp("(:|\\s+)" + key, "g"),
                    "$1" + this.colors[key]
                );
            });
            if (this.originalStylesheetCount === document.styleSheets.length) {
							console.log('------');
                // 如果之前没有插入就插入
                const style = document.createElement("style");
                style.innerText =
                    ".primaryColor{background-color:" + this.colors.primary + "}" + cssText;
                document.head.appendChild(style);
            } else {
							console.log('+++++++');
             
						    // 如果之前没有插入就修改
                document.head.lastChild.innerText =
                    ".primaryColor{background-color:" +
                    this.colors.primary +
                    "} " +
                    cssText;
										// console.log(cssText);
            }
        },
        getIndexStyle(url) {
					console.log('url'+url);
            let that = this;
            var request = new XMLHttpRequest();
            request.open("GET", url);
            request.onreadystatechange = function() {
                if (
                    request.readyState === 4 &&
                    (request.status == 200 || request.status == 304)
                ) {
                    // 调用本地的如果拿不到会得到html,html是不行的
                    if (request.response && !/DOCTYPE/gi.test(request.response)) {
                        that.originalStyle = that.getStyleTemplate(request.response);
                        that.writeNewStyle()
                    } else {
                        that.originalStyle = "";
                    }
                } else {
                    that.originalStyle = "";
                }
            };
            request.send(null);
        },
        getStyleTemplate(data) {
            const colorMap = {
                "#3a8ee6": "shade-1",
                "#409eff": "primary",
                "#53a8ff": "light-1",
                "#66b1ff": "light-2",
                "#79bbff": "light-3",
                "#8cc5ff": "light-4",
                "#a0cfff": "light-5",
                "#b3d8ff": "light-6",
                "#c6e2ff": "light-7",
                "#d9ecff": "light-8",
                "#ecf5ff": "light-9"
            };
            Object.keys(colorMap).forEach(key => {
                const value = colorMap[key];
                data = data.replace(new RegExp(key, "ig"), value);
            });
            return data;
				},	
			GetVersionStyle(value){
			let para={
			}
      VersionStyle(para).then((res)=>{
								let { Success,Msg } = res.data;
								if(Success)
								{
									console
									this.cssColor=res.data.Data;
                  this.cssColor.forEach(element => {
										console.log(element);
										console.log(value.SkinVersion);		
										this.cssUrl='';								
						        if(element.KeyStr===value.SkinVersion)
						           {
												this.colors.primary=element.StyleModel.Color;
												
												this.cssUrl=element.StyleModel.Path;
						          }
										});

										this.headerbackground=this.headerbackground+this.colors.primary;
																				console.log('-=--=-=--=');
									console.log(this.cssUrl);
									console.log(this.colors.primary);
										this.getIndexStyle(this.cssUrl);

								}
								else
								{
								}							
					 })			
		},	  				
				
				
		GetQQCustomerService(){
			let para={
			}
      QQCustomerService(para).then((res)=>{
								let { Success,Msg } = res.data;
								if(Success)
								{
									this.CustomerServiceUrl=res.data.Data.Value;
								}else
								{
								}							

					 })			
		},	  
      QRcode(){
				this.seeImageVisible=true;
			},
		      ...mapMutations(['SetShopInfo']),
		ChangeTime(){
			let para={
				id:JSON.parse(this.getuserstate()).TenancyId,
				input:this.LimitTime
			}
      TimeLimitSet(para).then((res)=>{
								let { Success,Msg } = res.data;
								if(Success)
								{
                  this.$message({
									message: Msg,
									type: 'success'
									});
									this.LimitTime=res.data.Data;
								}else
								{
                  this.$message({
									message: Msg,
									type: 'error'
								});
								}							

					 })			
		},
   HtmlValue(){
	   			let para={}
			           GetHtmlValue(para).then((res)=>{
						   this.value=res.data.Data;
					 })					 
   },
onProvincesChange(item) {
},		
		GetDistLsit()
		{
			let para={}
			           DistJsonList(para).then((res)=>{
						   this.options=res.data.Data;

					 })
		},
		ChangeDist()
		{	
            
						let para={
							DistId:this.value[this.value.length-1],
							HtmlValue:this.value.join(','),
							Count:this.value.length
							}
			           CreateShopDist(para).then((res)=>{
						//    this.options=res.data.Data;
					  let {Success,Msg}=res.data;
					  if(Success)
					  {
                         this.$message({
							message:Msg,
							type: 'success'
						});
					  }
					  else
					  {
	                    this.$message({
							message: Msg,
							type: 'error'
						});											  
					  }						 
					 })
			// console.log(this.value);
		},
		Dist()
		{
			this.DistVisible=true;
			this.GetDistLsit();
		},

		Limit(){
			this.LimitVisible=true;

		},
      handleChange(value) {
        console.log(value);
      },		
		getStoryInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           getShopInfor(para).then((res)=>{
						//  console.log(res);
						 let list=res.data;
						 if(list.lenght<1)
						 {

						 }
						 else
						 {
					
						//  this.sysUserName=res.data[0].Name;
						 this.LimitTime=res.data[0].TimeLimit;
						 this.SetShopInfo(res.data[0]);
						//  console.log(JSON.stringify(res.data[0]));
						//  console.log(this.getshopInfo())
						 }

					 })
		 },
			//获取用户状态信息 es6写法
						...mapGetters(['getuserstate']),
						...mapGetters(['getshopInfo']),						 
	  ...mapMutations(['ADD_LOGIN_USER']),
	  ...mapMutations(['SIGN_OUT']),
			onSubmit() {
				// console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function (a, b) {
			},
			Change(){				
				if(this.Form.OldPwd==''||this.Form.NewPwd=='')
				{
	                    this.$message({
							message: '请输入老密码和新密码',
							type: 'error'
						});													
				}
				else
				{
					if(this.Form.Confirm!=this.Form.NewPwd)
					{
	                    this.$message({
							message: '新密码两次输入不一致,请确认新密码是否正确',
							type: 'error'
						});	
					}
					else
					{
				let para={
                    id:JSON.parse(this.getuserstate()).Id,
					oldPassword:this.Form.OldPwd,
					newPassword:this.Form.NewPwd,
					Confirm:this.Form.Confirm,
				};
				ChangePassword(para).then((res)=>{                      
					  let {Success,Msg}=res.data;
					  if(Success)
					  {
                         this.$message({
							message:Msg,
							type: 'success'
						});
						this.FormVisible=false;
					    	this.Form={
				         	UserId:'',
				         	OldPwd:'',
							 NewPwd:'',
							 Confirm:''
			                }
					  }
					  else
					  {
	                    this.$message({
							message: Msg,
							type: 'error'
						});	
										  
					  }
				}).catch(err=>{alert('网络错误');})
					}
				}
				// let FormValue=  this.Form;
			},
			ChangePassword:function(){
					 this.Form.OldPwd='';
					 this.Form.NewPwd='';
				    this.Form.UserId=JSON.parse(this.getuserstate()).Id;
                    this.FormVisible=true;
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
                  requestLogout().then((res)=>{					 
					}).catch(error=>{
                 alert('网络错误');
				   });
					// sessionStorage.removeItem('user');
					this.SIGN_OUT();					 
					_this.$router.push('/login');
					//回到登陆页重新加载 重置路由vuex等状态
					window.location.reload()
				}).catch(() => {
				});
			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},

			showVersionStyle(value)
			{
				this.GetVersionStyle(value);
       // 默认从线上官方拉取最新css,2秒钟后做一个检查没有拉到就从本地在拉下
        let that = this;
        // 如果是记住用户的状态就需要，在主题切换的时候记录颜色值，在下次打开的时候从新赋值
				// this.colors.primary = localStorage.getItem('color')||this.colors.primary//例如
				// console.log(this.cssUrl+'------0000');
        // this.getIndexStyle(this.cssUrl);
        // setTimeout(function() {
        //     if (that.originalStyle) {
        //         return;
        //     } else {
        //         that.getIndexStyle(that.cssUrl);
        //     }
        // }, 2000);				               
			}
		},
		mounted() {		
      var user=JSON.parse(this.getuserstate());             
			if (user) {
				if(user.TenancyId.length>=2)
				{
				this.sysUserName = user.Name;
					this.getStoryInfo();
				}else
				{
				this.sysUserName = user.Name;
				}
				this.sysUserAvatar = this.userImg;
			}
			this.HtmlValue();	
			this.GetQQCustomerService();	  
			this.showVersionStyle(user); 
		},
		//父子组件生命周期过程中先于任意子组件回调周期完成前 完成用户信息状态建立在vuex中
		beforeMount(){			
			var user = sessionStorage.getItem('user');           
                //设置vuex用户状态
			this.ADD_LOGIN_USER(user);				
		},

	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';

	.containerfooterdiv{
     position:fixed; bottom:0; width:100%; 
	}
	 .containerfooter {
    background-color: #f2f2f2;
    color: #333;
    text-align: center;
    line-height: 30px;
  }
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//width:230px;
				height:60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
										z-index:999;

				flex:0 0 60px;
				width: 60px;
				     overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }	
			}
			// 导航栏宽度
			.menu-expanded{
										z-index:999;

				flex:0 0 160px;
				width: 160px;
				     overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }	
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: left;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
	// 调整导航栏鼠标移入宽度
	.el-submenu .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0 45px;
    min-width: 160px;
}
</style>


// WEBPACK FOOTER //
// Home.vue?4b4c1a70